import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const InteractiveWorkflow = () => {
    const { can } = useAuth();
    const navigate = useNavigate();

    // Definición de Hotspots (Áreas interactivas)
    // Usamos porcentajes para que sea 100% responsivo
    const hotspots = [
        { id: 1, name: 'Recepción', path: '/agenda', module: 'Agenda', top: '5%', left: '35%', width: '30%', height: '25%' },
        { id: 2, name: 'Servicios', path: '/servicios', module: 'Servicios', top: '25%', left: '65%', width: '30%', height: '35%' },
        { id: 3, name: 'Punto de Venta', path: '/facturacion', module: 'Ventas', top: '60%', left: '55%', width: '35%', height: '30%' },
        { id: 4, name: 'Historial', path: '/facturacion', module: 'Ventas', top: '60%', left: '10%', width: '35%', height: '30%' },
        { id: 5, name: 'Configuración', path: '/configuracion', module: 'Configuracion', top: '20%', left: '5%', width: '30%', height: '40%' }
    ].filter(spot => can(spot.module));

    return (
        <div className="relative w-full max-w-4xl mx-auto rounded-3xl overflow-hidden bg-[#020617] shadow-[0_0_50px_rgba(0,0,0,0.8)] group border border-white/10">
            {/* El Asset Maestro con mayor contraste */}
            <img 
                src="assets/img/workflow.png" 
                alt="PawSpa Workflow" 
                className="w-full h-auto block select-none pointer-events-none transition-all duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100 filter brightness-75 group-hover:brightness-100"
            />
            
            {/* Capa de Hotspots */}
            <div className="absolute inset-0">
                {hotspots.map((spot) => (
                    <div
                        key={spot.id}
                        onClick={() => navigate(spot.path)}
                        className="absolute cursor-pointer transition-all duration-300 rounded-2xl
                                 hover:bg-purple-500/10 hover:border-2 hover:border-purple-500/30
                                 active:scale-95 group/spot"
                        style={{
                            top: spot.top,
                            left: spot.left,
                            width: spot.width,
                            height: spot.height
                        }}
                    >
                        {/* Tooltip Estilizado */}
                        <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-slate-900/90 text-white px-3 py-1 
                                      rounded-lg text-xs font-bold opacity-0 group-hover/spot:opacity-100 
                                      translate-y-2 group-hover/spot:translate-y-0 transition-all duration-300 whitespace-nowrap border border-white/10">
                            {spot.name} ⚡
                        </div>
                    </div>
                ))}
            </div>

            {/* Overlay de Interacción */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 px-4 py-2 bg-slate-900/40 backdrop-blur-md rounded-full border border-white/10">
                <p className="text-white/60 text-[10px] uppercase tracking-widest font-bold">Modo Experiencia Interactiva Activo</p>
            </div>
        </div>
    );
};

export default InteractiveWorkflow;
